import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import { LabProvider } from './i18n/LabContext';
import { Component, useEffect, useRef, useState } from 'react';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Computers from './pages/Computers';
import PendingDevices from './pages/PendingDevices';
import Diskless from './pages/Diskless';
import Packages from './pages/Packages';
import Sessions from './pages/Sessions';
import Floor from './pages/Floor';
import Kassa from './pages/Kassa';
import Obuna from './pages/Obuna';
import SuperAdmin from './pages/SuperAdmin';
import SuperDashboard from './pages/super/SuperDashboard';
import SuperLabs from './pages/super/SuperLabs';
import SuperLabDetail from './pages/super/SuperLabDetail';
import SuperCreateLab from './pages/super/SuperCreateLab';
import SuperUsers from './pages/super/SuperUsers';
import SuperSubscriptions from './pages/super/SuperSubscriptions';
import SuperCatalog from './pages/super/SuperCatalog';
import SuperClubs from './pages/super/SuperClubs';
import TopupBonuses from './pages/TopupBonuses';
import StationRates from './pages/StationRates';
import Refunds from './pages/Refunds';
import LauncherThemes from './pages/LauncherThemes';
import BulkBookings from './pages/BulkBookings';
import BarPreOrders from './pages/BarPreOrders';
import Feedbacks from './pages/Feedbacks';
import LabInfoSettings from './pages/LabInfoSettings';
import Games from './pages/Games';
import Apps from './pages/Apps';
import SnackPOS from './pages/SnackPOS';
import Promo from './pages/Promo';
import Promotions from './pages/Promotions';
import Tournaments from './pages/Tournaments';
import Notifications from './pages/Notifications';
import Announcements from './pages/Announcements';
import Finance from './pages/Finance';
import Expenses from './pages/Expenses';
import Staff from './pages/Staff';
import CRM from './pages/CRM';
import Clients from './pages/Clients';
import Memberships from './pages/Memberships';
import Maintenance from './pages/Maintenance';
import Leaderboard from './pages/Leaderboard';
import Fiscal from './pages/Fiscal';
import PaymentSettings from './pages/PaymentSettings';
import LayoutEditor from './pages/LayoutEditor';
import AccessControl from './pages/AccessControl';
import Theme from './pages/Theme';
import Rewards from './pages/Rewards';
import AntiCheat from './pages/AntiCheat';
import Layout from './components/Layout';
import { ImpersonateProvider } from './i18n/ImpersonateContext';

class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { hasError: false, error: null }; }
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a0a0f', color: '#fff', flexDirection: 'column', gap: 16, padding: 24 }}>
        <div style={{ fontSize: 48 }}>⚠️</div>
        <div style={{ fontSize: 20, fontWeight: 800 }}>Xatolik yuz berdi</div>
        <div style={{ fontSize: 13, color: '#6b7280', maxWidth: 400, textAlign: 'center' }}>{this.state.error?.message}</div>
        <button onClick={() => this.setState({ hasError: false, error: null })} style={{ marginTop: 8, padding: '10px 24px', borderRadius: 10, background: '#27E0FF22', border: '1px solid #27E0FF50', color: '#27E0FF', cursor: 'pointer', fontWeight: 700 }}>
          Qayta urinish
        </button>
      </div>
    );
  }
}

const PrivateRoute = ({ children }) => {
  return localStorage.getItem('token') ? children : <Navigate to="/login" />;
};

function DebtAlert() {
  const [alerts, setAlerts] = useState([]);
  const esRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
    const es = new EventSource(`${apiBase}/owner/events?token=${encodeURIComponent(token)}`);
    esRef.current = es;

    es.addEventListener('debt_alert', (e) => {
      const data = JSON.parse(e.data);
      const id = Date.now();
      setAlerts(prev => [...prev, { id, ...data }]);
      // Ovozli signal
      try {
        const ctx = new (window.AudioContext || window.webkitAudioContext)();
        let t = ctx.currentTime;
        for (let i = 0; i < 3; i++) {
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.connect(gain); gain.connect(ctx.destination);
          osc.type = 'sawtooth';
          osc.frequency.value = 660;
          gain.gain.setValueAtTime(0.4, t + i * 0.5);
          gain.gain.exponentialRampToValueAtTime(0.001, t + i * 0.5 + 0.4);
          osc.start(t + i * 0.5); osc.stop(t + i * 0.5 + 0.4);
        }
      } catch {}
      // 15 soniyadan keyin avtomatik yopiladi
      setTimeout(() => setAlerts(prev => prev.filter(a => a.id !== id)), 15000);
    });

    return () => { es.close(); };
  }, []);

  const dismiss = (id) => setAlerts(prev => prev.filter(a => a.id !== id));

  if (!alerts.length) return null;
  return (
    <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999, display: 'flex', flexDirection: 'column', gap: 12 }}>
      {alerts.map(a => (
        <div key={a.id} style={{
          background: '#1a0808', border: '2px solid #ef4444',
          borderRadius: 14, padding: '16px 20px', minWidth: 320, maxWidth: 400,
          boxShadow: '0 0 30px rgba(239,68,68,0.4)',
          animation: 'slideIn 0.3s ease',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 12, color: '#f87171', fontWeight: 700, marginBottom: 6, textTransform: 'uppercase', letterSpacing: 1 }}>
                ⚠️ Seans yakunlandi — qarz bor
              </div>
              <div style={{ fontSize: 16, color: '#fff', fontWeight: 800, marginBottom: 10 }}>{a.user_name}</div>
              {Number(a.debt) > 0 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', background: 'rgba(239,68,68,0.1)', borderRadius: 8, padding: '8px 12px', marginBottom: 6 }}>
                  <span style={{ fontSize: 12, color: '#f87171' }}>💳 Balans qarzi</span>
                  <span style={{ fontSize: 14, color: '#ef4444', fontWeight: 800 }}>{Number(a.debt).toLocaleString()} so'm</span>
                </div>
              )}
              {Number(a.bar_debt) > 0 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', background: 'rgba(239,68,68,0.1)', borderRadius: 8, padding: '8px 12px', marginBottom: 6 }}>
                  <span style={{ fontSize: 12, color: '#f87171' }}>🍕 Bar qarzi</span>
                  <span style={{ fontSize: 14, color: '#ef4444', fontWeight: 800 }}>{Number(a.bar_debt).toLocaleString()} so'm</span>
                </div>
              )}
              {(Number(a.debt) > 0 && Number(a.bar_debt) > 0) && (
                <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid rgba(239,68,68,0.3)', paddingTop: 8, marginTop: 4 }}>
                  <span style={{ fontSize: 12, color: '#fca5a5', fontWeight: 700 }}>Jami qarz</span>
                  <span style={{ fontSize: 16, color: '#ef4444', fontWeight: 900 }}>{(Number(a.debt) + Number(a.bar_debt)).toLocaleString()} so'm</span>
                </div>
              )}
            </div>
            <button onClick={() => dismiss(a.id)} style={{
              background: 'transparent', border: 'none', color: '#6b7280',
              fontSize: 18, cursor: 'pointer', padding: 0, marginLeft: 12, flexShrink: 0,
            }}>✕</button>
          </div>
          <button onClick={() => dismiss(a.id)} style={{
            marginTop: 12, width: '100%', background: 'rgba(239,68,68,0.15)',
            border: '1px solid rgba(239,68,68,0.4)', color: '#ef4444',
            padding: '8px 0', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 700,
          }}>Tushundim</button>
        </div>
      ))}
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
    <LanguageProvider>
      <LabProvider>
      <HashRouter>
        <ImpersonateProvider>
        <DebtAlert />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="computers" element={<Computers />} />
            <Route path="pending-devices" element={<PendingDevices />} />
            <Route path="diskless" element={<Diskless />} />
            <Route path="packages" element={<Packages />} />
            <Route path="sessions" element={<Sessions />} />
            <Route path="floor" element={<Floor />} />
            <Route path="kassa" element={<Kassa />} />
            <Route path="bookings" element={<BulkBookings />} />
            <Route path="bar-preorders" element={<BarPreOrders />} />
            <Route path="feedbacks" element={<Feedbacks />} />
            <Route path="lab-info" element={<LabInfoSettings />} />
            <Route path="games" element={<Games />} />
            <Route path="apps" element={<Apps />} />
            <Route path="snack" element={<SnackPOS />} />
            <Route path="promo" element={<Promo />} />
            <Route path="promotions" element={<Promotions />} />
            <Route path="tournaments" element={<Tournaments />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="announcements" element={<Announcements />} />
            <Route path="finance" element={<Finance />} />
            <Route path="expenses" element={<Expenses />} />
            <Route path="staff" element={<Staff />} />
            <Route path="clients" element={<Clients />} />
            <Route path="crm" element={<CRM />} />
            <Route path="memberships" element={<Memberships />} />
            <Route path="maintenance" element={<Maintenance />} />
            <Route path="leaderboard" element={<Leaderboard />} />
            <Route path="fiscal" element={<Fiscal />} />
            <Route path="payment-settings" element={<PaymentSettings />} />
            <Route path="layout-editor" element={<LayoutEditor />} />
            <Route path="obuna" element={<Obuna />} />
            <Route path="super-admin" element={<SuperAdmin />} />
            <Route path="topup-bonuses" element={<TopupBonuses />} />
            <Route path="refunds" element={<Refunds />} />
            <Route path="launcher-themes" element={<LauncherThemes />} />
            <Route path="access-control" element={<AccessControl />} />
            <Route path="theme" element={<Theme />} />
            <Route path="rewards" element={<Rewards />} />
            <Route path="anticheat" element={<AntiCheat />} />
            <Route path="station-rates" element={<StationRates />} />
            <Route path="super" element={<SuperDashboard />} />
            <Route path="super/labs" element={<SuperLabs />} />
            <Route path="super/labs/new" element={<SuperCreateLab />} />
            <Route path="super/labs/:id" element={<SuperLabDetail />} />
            <Route path="super/users" element={<SuperUsers />} />
            <Route path="super/subscriptions" element={<SuperSubscriptions />} />
            <Route path="super/catalog" element={<SuperCatalog />} />
            <Route path="super/clubs" element={<SuperClubs />} />
          </Route>
        </Routes>
        </ImpersonateProvider>
      </HashRouter>
      </LabProvider>
    </LanguageProvider>
    </ErrorBoundary>
  );
}
